import { BOARD } from '../../model/msg/board';
import { getLoadingBarTpl } from '../../model/tpl/loadingbar';
import { getPaginationSearchTpl } from '../../model/tpl/paginationNormal';
import { getNoDataTpl } from '../common/tpl';
import { getPowerbookListTpl } from './tpl';
import { getDatasWithOption } from '../../utils/service';
import { locationOriginRegex, isDefined, not, isNotDefined, truthy, notSingleEle, parseInt10, getUriParams, getUriCombinedParams, numberWithCommas, minNumber } from '../../utils/util';

class PowerbookList {
  constructor(options) {
    const _ = this;

    if (isNotDefined(options)) throw new Error('PowerbookList constructor require options object');

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
//       queryStr: '',
      keywordStr: '',
      pageIndex: 1,
      pageSize: 20,
      paginationSize: 5,
      serviceAlias: 'lineage',
      global: window
    }, options);

    _.wrap = $(_.option.wrap);

    _.paginationBtnsWrap = $('.pagination-container .pagination-list', _.wrap);

    _.locationParams = getUriParams(document.location.href) || {};

    // _.queryStr = (_.option.queryStr) ? _.option.queryStr : '';
    _.keywordStr = (_.option.keywordStr) ? _.option.keywordStr : '';

    _.currentPage = (_.option.pageIndex >= 1) ? _.option.pageIndex : 1;

    _.paginationNavi = {};

    // _.decodedQueryStr = window.decodeURIComponent(_.queryStr);
    _.decodedKeywordStr = window.decodeURIComponent(_.keywordStr);

    _.tpls = {
      retryLater: `<li>${BOARD.RETRY_LATER}</li>`
    };
  }

  init() {
    const _ = this;

    if (notSingleEle(_.wrap)) throw new Error('PowerbookList require options has a single wrap');

    let $boardWrap = $('.search-article', _.wrap);
    $boardWrap.empty();

    _.setSearchResultCount(0);

    _.setLoadingBar(true);

    _.setData();

    return _;
  }

  setData() {
    const _ = this;

    if (_.keywordStr === '') { // if (_.queryStr === '') {
      _.setLoadingBar(false);
      _.setNoData();
      return;
    }

    getDatasWithOption([{
      type: 'GET',
      url: `${_.option.apiDomain}/lineage/search/v2/powerbook`,
      dataType: 'json',
      data: {
        // query: _.decodedQueryStr,
        // page_no: _.currentPage,
        // page_size: _.option.pageSize,
        // pagination_size: _.option.paginationSize
        serviceAlias: _.option.serviceAlias,
        keyword: _.decodedKeywordStr,
        page: _.currentPage,
        size: _.option.pageSize,
        // page_size: _.option.pageSize,
        pagination_size: _.option.pagination_size
      }

    }], (data) => {
        // console.log('## data : ', data);
      _.setLoadingBar(false);
      _.setInstance(data);

    }, (data) => {
      _.setLoadingBar(false);
      _.displayError(BOARD.RETRY_LATER);
    });
  }

  setInstance(data) {
    console.log('## setInstance() ');
    const _ = this;

    if (isNotDefined(data.list) || not(Array.isArray)(data.list) || data.list.length <= 0) {
      _.setNoData();
      return;
    }

    let tpl = '<ul>', url = '', encodedKeyword = '';
    data.list.forEach(function (value, index, array) {
      // url = (value.url || '#').replace(locationOriginRegex, '');
      encodedKeyword = value.keyword ? value.keyword.replace(/<[^>]*>/g, '') : '';
      url = encodedKeyword ? '/powerbook/wiki?keyword=' + encodeURIComponent(encodedKeyword) : '/powerbook/index';

      tpl += getPowerbookListTpl({
        title: value.keyword || '',
        thumbnail: value.thumbnail,
        link: url,
        description: value.contents || '',
        // powerbookType: value.powerbook_type
      });
    });
    tpl += '</ul>';

    let $boardWrap = $('.search-article', _.wrap);
    $boardWrap.empty().append(tpl);

    _.paginationNavi.start = Math.floor((data.pagination.page - 1) / _.option.paginationSize) * _.option.paginationSize + 1;
    _.paginationNavi.end = minNumber(Math.ceil(data.pagination.page / _.option.paginationSize) * _.option.paginationSize, data.pagination.endPage);
    _.paginationNavi.maxPageNo = data.pagination.endPage;
    _.paginationNavi.currentPage = data.pagination.page;

    console.log('# _.paginationNavi : ', _.paginationNavi);
    _.setPagination(_.paginationNavi);
    _.currentPage = data.pagination.page;

    _.setSearchResultCount(data.pagination.total);
  }

  setPagination(paginationObj) {
    const _ = this;

    _.paginationBtnsWrap.empty().append(getPaginationSearchTpl(paginationObj));

    let pageBtns = $('li a', _.paginationBtnsWrap);
    pageBtns.on('click', function (evt) {
      evt.preventDefault();

      document.location.href = getUriCombinedParams(document.location.pathname, {
        // query: _.queryStr,
        keyword: _.keywordStr,
        page: parseInt10($(this).attr('data-paging'))
      });
    });
  }

  setSearchResultCount(number) {
    const wrap = $('.search-util__result .count', this.wrap),
      countStr = numberWithCommas(number);

    wrap.html(`${countStr}`);
  }

  setNoData() {
    const _ = this;
    // this.wrap.empty().append(getNoDataTpl(_.decodedQueryStr));
    this.wrap.empty().append(getNoDataTpl(_.decodedKeywordStr));
  }

  setLoadingBar(flag) {
    const _ = this;

    if (truthy(flag)) {
      $('.search-article--powerbook', _.wrap).append(getLoadingBarTpl());

    } else {
      $('.loadingbar', _.wrap).remove();
    }
  }

  displayError(msg) {
    const _ = this,
      $boardWrap = $('.search-article', _.wrap);

    switch (msg) {
      case BOARD.RETRY_LATER:
        $boardWrap.empty().append(_.tpls.retryLater);
        break;
    }
  }
}

export default PowerbookList;


// WEBPACK FOOTER //
// ./_src/js/search/powerbook2/PowerbookList.js